import { render } from "./ResourceState.vue?vue&type=template&id=108d2002&scoped=true"
import script from "./ResourceState.vue?vue&type=script&lang=js"
export * from "./ResourceState.vue?vue&type=script&lang=js"

import "./ResourceState.vue?vue&type=style&index=0&id=108d2002&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108d2002"]])

export default __exports__